export default __webpack_public_path__ + "static/media/14.80a041e2.jpg";